module.exports = __webpack_public_path__ + "img/logo.8659b94d.png";